const DEFAULT_PIXEL_SIZE = parseInt(window.getComputedStyle(document.documentElement).fontSize, 10) || 16

/**
 * Converts a given size in pixels to rem
 *
 * @param {number|string} size Size in pixels
 * @returns {string} Size in rem
 */
export const rem = size => {
  const pixels = parseInt(size, 10)
  return `${parseFloat((pixels / DEFAULT_PIXEL_SIZE).toPrecision(7))}rem`
}

/* NOTE: Eventually use the owl-kit-components function */
export const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return `rgba(${r},${g},${b},${alpha})`
  }

  return `rgb(${r},${g},${b})`
}
